import React, { useState } from "react";
import { CaretDown } from "@phosphor-icons/react";
import { FAQ, FAQ_SECTION } from "../../data/startPageContent";
import useStartReveal from "./useStartReveal";
import "./StartFaq.css";

/**
 * Accessible accordion, 1:1 with the page's FAQPage JSON-LD (plan §4.8).
 * Defaults to the /start FAQ; `/for` pages may pass their own `items` / `title`.
 */
export default function StartFaq({ items = FAQ, overline = FAQ_SECTION.overline, title = FAQ_SECTION.title }) {
  const ref = useStartReveal();
  const [open, setOpen] = useState(0);

  return (
    <section id="start-faq" className="st-section st-section--alt st-faq" aria-labelledby="st-faq-title">
      <div className="st-container st-reveal" ref={ref}>
        <p className="st-overline st-center">{overline}</p>
        <h2 id="st-faq-title" className="st-h2 st-center">{title}</h2>
        <div className="st-faq-list">
          {items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.question} className={`st-faq-item${isOpen ? " st-faq-item--open" : ""}`}>
                <h3 className="st-faq-q">
                  <button
                    type="button"
                    id={`st-faq-btn-${i}`}
                    className="st-faq-btn"
                    aria-expanded={isOpen}
                    aria-controls={`st-faq-panel-${i}`}
                    onClick={() => setOpen(isOpen ? null : i)}
                  >
                    <span>{item.question}</span>
                    <CaretDown size={18} weight="bold" className="st-faq-caret" aria-hidden="true" />
                  </button>
                </h3>
                <div
                  id={`st-faq-panel-${i}`}
                  role="region"
                  aria-labelledby={`st-faq-btn-${i}`}
                  className="st-faq-panel"
                  hidden={!isOpen}
                >
                  <div className="st-faq-panel-inner">
                    <p>{item.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
